import { Component, OnInit } from '@angular/core';
import { getGatewayListingDatatableConfig } from './gateway-listing.dt.config';
import { Observable }  from 'rxjs/Observable';
import { Subscription } from 'rxjs/Rx';
import { Router } from '@angular/router';
import { GatewayService }  from '../gateway.service';
import { NetworkService }  from '../../networks/network.service';
import CommonConstants from '../../common/common-constants';
import GatewayDto  from '../dto/gateway-dto';
import { Response } from '@angular/http';
import { JobsNotifierService } from '../../../../../services/job-notifier.service';
import { JobConstants } from '../../../../../../common/utils/job-constants';
import { RefreshSharedService } from '../../../../../refresh-shared-service';
import { GlobalVariables } from '../../../../../../common/global-variables';
import { AuthService } from '../../../../../auth/auth.service';
const _ = require('lodash');

const GATEWAY: string = 'gateway';
@Component({
    selector: 'gateway-listing',
    template: require('./gateway-listing.html'),
    styles: [require('./gateway-listing.scss')],
    providers: [ GatewayService, NetworkService ]
})
export class GatewayListing implements OnInit {
    private subscribeHandler: Subscription;
    private gateways: Array<GatewayDto> = [];
    private canAddGateway: boolean = true;
    private canEditGateway: boolean = false;
    private canDeleteGateway: boolean = false;
    private canForceSyncGateway: boolean = false;
    private canRedeployGateway: boolean = false;
    private selectedGateway: GatewayDto = null;
    private showDeleteDialog: boolean = false;
    private timer = null;
    private tableSettings: Object = {};
    private tableConfig: Object = {};
    private forceSyncEdge: boolean = false;
    private redeployEdge: boolean = false;
    private showActionsDialog: boolean = false;
    private actionDialogTitle: string = '';
    private isNetworkCallInProgress: boolean = false;
    private networkOperationFailed: boolean = false;
    private errorMessage: string;
    private showFailureDialog: boolean = false;
    private failureReasons: string = '';
    private canShowFailures: boolean = false;
    private jobCompletionSubscription: Subscription;
    private rsService: RefreshSharedService;
    private refreshSubscription: Subscription;
    private currentClassName: string = '';
    private isSystemAdmin: boolean = false;
    
    constructor(private gatewayService: GatewayService,
                public authService: AuthService,
                private router: Router,
                private jobsNotifierService: JobsNotifierService,
                private rss: RefreshSharedService) {
         this.tableConfig = getGatewayListingDatatableConfig();
         Object.assign(this.tableSettings, this.tableConfig, {'data': []});
         this.jobCompletionSubscription = this.jobsNotifierService.
            getCompletedJobs(JobConstants.SERVICES['NetworkingLifecycleJob']).subscribe(jobs => {
                this.refreshNetworks(jobs);
            },
            error => {},
            () => {}
        );
        this.rsService = rss;
        this.currentClassName = 'GatewayListing';
        let roles = (this.authService.loggedInUserInfo && this.authService.loggedInUserInfo.roles) ? this.authService.loggedInUserInfo.roles : [];
        if (_.includes(roles, 'System Administrator')) {
            this.isSystemAdmin = true;
        }
    }

    ngOnInit() {
        this.getAllGateways();
        this.refreshSubscription = this.rsService.getRefreshParam()
        .subscribe (
        item => {
          this.handleEmittedValues(item);
        });
    
        this.rsService.setParam({
            'loadedComponent': this.currentClassName, 
            'detailPageIDName': '',
            'shouldReloadInventoryTree': false
        });
    }

    handleEmittedValues(refreshItem) {
        if (refreshItem.loadedComponent === this.currentClassName) {
            this.gatewayService.gateways = [];
            this.getAllGateways();
        }
    }

    getAllGateways(): void {
        this.gatewayService.getAllGateways();
    }

    onCreate(event): void {
         this.router.navigate(['services/networking/gateways/new']);
    }

    onEdit(event): void {
        let navigateToUrl: string = 'services/networking/gateways/edit/' + this.selectedGateway.objectId;
        this.router.navigate([navigateToUrl]);
    }

    onForceSync(event): void {
        if (this.canForceSyncGateway) {
            this.networkOperationFailed = false;
            this.errorMessage = '';
            this.showActionsDialog = true;
            this.actionDialogTitle = 'Force Sync';
            this.forceSyncEdge = true;
        }
    }

    onRedeploy(event): void {
        if (this.canForceSyncGateway) {
            this.networkOperationFailed = false;
            this.errorMessage = '';
            this.showActionsDialog = true;
            this.actionDialogTitle = 'Redeploy Router';
            this.redeployEdge = true;
        }
    }

    onActionPerformed(event): void {
        this.isNetworkCallInProgress = true;
        this.errorMessage = '';
        if (this.forceSyncEdge) {
            this.forceSyncEdge = false;
            this.subscribeHandler = this.gatewayService.forceSync(this.selectedGateway.objectId)
            .subscribe(
                    gateways => {
                        this.getAllGateways();
                        this.showActionsDialog = false;
                        this.isNetworkCallInProgress = false;
                        this.disableGatewayActions();
                    },
                    error => this.handleNetworkOpreationError(error)
            );
        }
        if (this.redeployEdge) {
            this.redeployEdge = false;
            this.subscribeHandler = this.gatewayService.redeployEdge(this.selectedGateway.objectId)
            .subscribe(
                    gateways => {
                        this.getAllGateways();
                        this.showActionsDialog = false;
                        this.isNetworkCallInProgress = false;
                        this.disableGatewayActions();
                    },
                    error => this.handleNetworkOpreationError(error)
            );
        }
    }

    
    onGatewaySelected(event): void {
        if (event && event.value && event.value instanceof Array ) {
           if (event.value[0]) {
                this.selectedGateway = event.value[0] as GatewayDto;
                let gatewayId: String = this.selectedGateway.objectId;
                this.subscribeHandler = this.gatewayService.getPermissions(gatewayId)
                    .subscribe(
                    (permission: any) => {
                        this.canAddGateway = permission.ADD;
                        this.canEditGateway = permission.EDIT;
                        this.canDeleteGateway = permission.DELETE;
                        this.canRedeployGateway = permission.REDEPLOY;
                        this.canForceSyncGateway = permission.FORCE_SYNC;
                        this.canShowFailures = this.isItinFailedState(this.selectedGateway);
                    },
                    error => {
                        this.canAddGateway = true;
                        this.canEditGateway = true;
                        this.canDeleteGateway = true;
                        this.canRedeployGateway = true;
                        this.canForceSyncGateway = true;
                        this.canShowFailures = false;
                    }
                );
           } else {
                this.selectedGateway = null;
                this.canAddGateway = true;
                this.canEditGateway = false;
                this.canDeleteGateway = false;
                this.canRedeployGateway = false;
                this.canForceSyncGateway = false;
                this.canShowFailures = false;
           }
        }
    }

    disableGatewayActions() {
        this.selectedGateway = null;
        this.canEditGateway = false;
        this.canDeleteGateway = false;
        this.canRedeployGateway = false;
        this.canForceSyncGateway = false;
        this.canShowFailures = false;
    }

    onDelete(): void {
        this.isNetworkCallInProgress = true;
        this.networkOperationFailed = false;
        this.errorMessage = '';
        this.subscribeHandler = this.gatewayService.deleteGateway(this.selectedGateway.objectId)
            .subscribe(
            gateways => {
                this.isNetworkCallInProgress = false;
                this.getAllGateways();
                this.showDeleteDialog = false;
                this.disableGatewayActions();
            },
            error => this.handleNetworkOpreationError(error)
        );
    }

    logError(error, origin: String = ''): void {
        console.error('Error: ', error, (origin !== '') ? ' Error from ' + origin : '');
    }

    handleNetworkOpreationError(error: any ) {
        this.networkOperationFailed = true;
        this.isNetworkCallInProgress = false;
        this.errorMessage = error.errorMessage;
    }

    onDeleteClicked(event) {
        this.networkOperationFailed = false;
        this.errorMessage = '';
        this.showDeleteDialog = true;
    }

    onShowshowFailureDialogClosed(event) {
        if (!event) {
            this.onFailureDialogCancel();
        }
    }

    onFailureDialogCancel() {
        this.showFailureDialog = false;
        this.failureReasons = '';
    }

    isItinFailedState(gateway): boolean {
        if (!gateway) {
            return false;
        }
        if (gateway.state === CommonConstants.STATE.NOT_REALIZED || gateway.state === CommonConstants.STATE.ERROR) {
            return true;
        }
        return false;
    }

    onShowFailure(event) {
        this.showFailureDialog = true;
        this.isNetworkCallInProgress = true;
        let gatewayId = this.selectedGateway.objectId;
        this.subscribeHandler = this.gatewayService.getGateway(gatewayId)
        .subscribe(
            (network: any) => {
                this.isNetworkCallInProgress = false;
                this.failureReasons = network.jobDetails.errorMessage;
            },
            error => this.handleNetworkOpreationError(error)
        );
    }

    refreshNetworks(jobs) {
        let workflowType: string;
        for (let index: number = 0; index < jobs.length; ++index) {
            workflowType = jobs[index].workflowType;
            if (workflowType.indexOf('GATEWAY') !== -1) {
                this.gatewayService.getAllGateways();
                break;
            }
        }
    }

    ngOnDestroy() {
        if (this.subscribeHandler) {
            this.subscribeHandler.unsubscribe();
        }

        this.rsService.resetParam();
        if (this.refreshSubscription) {
            this.refreshSubscription.unsubscribe();
        }

        if (this.jobCompletionSubscription) {
            this.jobCompletionSubscription.unsubscribe();
            this.jobsNotifierService.unsubscribeService(JobConstants.SERVICES['NetworkingLifecycleJob']);
        }
    }

    showImportGatewayDialog() {
        if (this.isSystemAdmin) {
                this.router.navigate(['services/networking/gateways/import']);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/networking/networking-vc/gateways/listing/gateway-listing.component.ts